import { DsImageProps } from '@am92/react-design-system'

import { T_LANDING_PAGE_CONSTANTS } from './Landing.PageConstants/TYPES'

import CHALLENGE_FRIENDS_FEATURE from '~/src/Assets/LANDING/CHALLENGE_FRIENDS_FEATURE'
import CONTRIBUTE_FEATURE from '~/src/Assets/LANDING/CONTRIBUTE_FEATURE'
import CREATE_COMPETITIONS_FEATURE from '~/src/Assets/LANDING/CREATE_COMPETITIONS_FEATURE'
import EARN_BADGES_FEATURE from '~/src/Assets/LANDING/EARN_BADGES_FEATURE'
import ENHANCE_READING_FEATURE from '~/src/Assets/LANDING/ENHANCE_READING_FEATURE'
import MANAGE_AND_TRACK_FEATURE from '~/src/Assets/LANDING/MANAGE_AND_TRACK_FEATURE'
import UNLOCK_AVATARS_FEATURE from '~/src/Assets/LANDING/UNLOCK_AVATARS_FEATURE'

export type T_CHILD_FEATURES =
  | 'ENHANCE_READING'
  | 'UNLOCK_AVATARS'
  | 'CHALLENGE_FRIENDS'
  | 'EARN_BADGES'
export type T_ADULT_FEATURES =
  | 'CREATE_COMPETITIONS'
  | 'MANAGE_AND_TRACK'
  | 'CONTRIBUTE'

export type T_FEATURES = T_CHILD_FEATURES | T_ADULT_FEATURES

export const CHILD_FEATURES: T_CHILD_FEATURES[] = [
  'ENHANCE_READING',
  'UNLOCK_AVATARS',
  'CHALLENGE_FRIENDS',
  'EARN_BADGES'
]

export const ADULT_FEATURES: T_ADULT_FEATURES[] = [
  'CREATE_COMPETITIONS',
  'MANAGE_AND_TRACK',
  'CONTRIBUTE'
]

export const FEATURE_IMAGE_MAP: Record<T_FEATURES, DsImageProps['srcSet']> = {
  ENHANCE_READING: ENHANCE_READING_FEATURE,
  UNLOCK_AVATARS: UNLOCK_AVATARS_FEATURE,
  CHALLENGE_FRIENDS: CHALLENGE_FRIENDS_FEATURE,
  EARN_BADGES: EARN_BADGES_FEATURE,
  CREATE_COMPETITIONS: CREATE_COMPETITIONS_FEATURE,
  MANAGE_AND_TRACK: MANAGE_AND_TRACK_FEATURE,
  CONTRIBUTE: CONTRIBUTE_FEATURE
}

export type T_LANDING_PAGE_CONSTANTS_KEYS = keyof T_LANDING_PAGE_CONSTANTS

export const FEATURE_TEXT_KEY_MAP: Record<
  T_FEATURES,
  {
    title: T_LANDING_PAGE_CONSTANTS_KEYS
    description: T_LANDING_PAGE_CONSTANTS_KEYS
  }
> = {
  ENHANCE_READING: {
    title: 'FEATURES_ENHANCE_READING_TITLE',
    description: 'FEATURES_ENHANCE_READING_DESCRIPTION'
  },
  UNLOCK_AVATARS: {
    title: 'FEATURES_UNLOCK_AVATARS_TITLE',
    description: 'FEATURES_UNLOCK_AVATARS_DESCRIPTION'
  },
  CHALLENGE_FRIENDS: {
    title: 'FEATURES_CHALLENGE_FRIENDS_TITLE',
    description: 'FEATURES_CHALLENGE_FRIENDS_DESCRIPTION'
  },
  EARN_BADGES: {
    title: 'FEATURES_EARN_BADGES_TITLE',
    description: 'FEATURES_EARN_BADGES_DESCRIPTION'
  },
  CREATE_COMPETITIONS: {
    title: 'FEATURES_CREATE_COMPETITIONS_TITLE',
    description: 'FEATURES_CREATE_COMPETITIONS_DESCRIPTION'
  },
  MANAGE_AND_TRACK: {
    title: 'FEATURES_MANAGE_AND_TRACK_TITLE',
    description: 'FEATURES_MANAGE_AND_TRACK_DESCRIPTION'
  },
  CONTRIBUTE: {
    title: 'FEATURES_CONTRIBUTE_TITLE',
    description: 'FEATURES_CONTRIBUTE_DESCRIPTION'
  }
}
